'use client';

import SettingConfig from '@module/config/setting';
import { cn } from '@module/lib/utils';
import useIsDarkModeStore from '@module/stores/useIsDarkModeStore';
import type { ReactNode } from 'react';

interface Props {
  text?: string;
  content?: ReactNode;
  className?: string;
}

function NotFoundDisplay({ text, content, className }: Props) {
  const { isDark } = useIsDarkModeStore();

  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center whitespace-pre-wrap break-words pt-[50px] pb-20 text-center',
        className,
      )}
    >
      <img
        className='block h-[100px]'
        src={`${SettingConfig.S3_BUCKET_URL}/img/icon/${isDark ? 'search_none_dark' : 'search_none.499e766'}.svg`}
        alt='no search'
      />
      {text && <p className='mt-5 whitespace-pre-wrap text-colorFg18'>{text}</p>}
      {content && content}
    </div>
  );
}

export default NotFoundDisplay;
